if (!customElements.get('product-form') || !customElements.get('custom-product-form-updated')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
  
      this.form = this.querySelector('form');
      if (!this.form) {
        return;
      }
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
      this.handleErrorMessage();
  
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');
  
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
  
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
  
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
  
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
  
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
customElements.define('product-form', ProductForm);
  
  
  class CustomProductForm extends HTMLElement {
    constructor() {
      super();
  
      this.form = this.querySelector('form');
      console.log(this.form);
      if (!this.form) {
        return;
      }
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
     
      const productWrapper = this.closest(".product");
      const variantPicker = productWrapper.querySelector("variant-selects");
      
      const selectedVariants = variantPicker.state.selectedVariants.map((selectedVariant) => ({ title: `${selectedVariant.title}`, quantity: selectedVariant.quantity }));
      if(selectedVariants.length === 0){
        this.handleErrorMessageForScentedProduct("Please Select at least one scent.");
        this.form.querySelector('[name=id]').disabled = true;
        return;
      }else{
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.handleErrorMessage();
      this.handleErrorMessageForScentedProduct();
      const packId = (new Date().getTime()).toString();
      let isSubscribed = false;
      let frequencyIndex = -1;
      const subscriptionInput = document.querySelector(`[name="selling_plan"][form="${this.form.getAttribute('id')}"]`);
      const subscriptionEnabled = document.querySelector('.skio-group-input:checked') ? true : false;
      if (subscriptionEnabled) {
        isSubscribed = document.querySelector('.skio-group-input:checked') && !document.querySelector('.skio-group-input:checked').hasAttribute("skio-one-time");
        frequencyIndex = document.querySelector(".skio-plan-picker .skio-frequency")?.selectedIndex;
      }
  
      console.log("selectedVariants", selectedVariants);
  
      const quantity = 1;
      const productVariants = variantPicker.getVariantData();
      const itemsArray = selectedVariants.map((selectedVariant) => {
        const variant = productVariants.find((variant) => {
          const variantOptions = variant.options.map((option) => option.toLowerCase());
          let variantHasPackOptions = false;
          for (const option of variantOptions){
            if(option.indexOf("pack") > -1){
              variantHasPackOptions = true;
              break;
            }
          }
          let selectedVariantTitle = variantHasPackOptions ? `${selectedVariant.title} / 1 Pack` : selectedVariant.title;
          return variant.title === selectedVariantTitle
        });
        //let temp = { id: variant.id, quantity: selectedVariant.quantity, properties: { _pack_id: packId }, title: `${variant.title} X ${selectedVariant.quantity}` };
        let temp = { id: variant.id, quantity: selectedVariant.quantity};
        if (isSubscribed && variant.selling_plan_allocations.length) {
          temp["selling_plan"] = subscriptionInput?.value;
          // temp["selling_plan"] = variant.selling_plan_allocations[frequencyIndex].selling_plan_id;
        }
        return temp;
      });
  
      //itemsArray[0].properties['_is_main'] = true;
      //itemsArray[0].properties['_pack_content'] = itemsArray.map((item) => item.title).join(',');
      const formData = { items: itemsArray };
     const cart_add_url = `${window.Shopify.routes.root}cart/add.js`;
     fetch(cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsArray })
        })
        .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: itemsArray[0].id,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          return;
        }
    
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: itemsArray[0].id,
          cartData: response,
        });
    
        this.cart.renderContents(response);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      });

      }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
  
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    handleErrorMessageForScentedProduct(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = document.querySelector('.error-message-scented-wrapper');

      if (!this.errorMessageWrapper) return;
      this.errorMessage = document.querySelector('.error-message-scented');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }else {
        return;
      }

      this.errorMessageDiv = document.querySelector('.error-message-scented-wrapper');
      this.infContainer = document.querySelector('.product__info-container');
      if (!this.errorMessageDiv || !this.infContainer) return;

      this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if (this.viewportWidth < 1024) {
        if(errorMessage.indexOf('at least one scent.') > -1){
          window.scrollTo({
            top: this.errorMessageDiv.previousElementSibling.offsetTop,
            behavior: 'smooth'
          });
        }else{
          window.scrollTo({
            top: this.errorMessageDiv.offsetTop,
            behavior: 'smooth'
          });
        }
      }else {
        if(errorMessage.indexOf('at least one scent.') > -1) {
          this.infContainer.scrollTop = this.errorMessageDiv.previousElementSibling.offsetTop;
        }else{
          this.infContainer.scrollTop = this.infContainer.scrollHeight;
        }
      }
    }
  }
 customElements.define('custom-product-form-updated', CustomProductForm);
  
}